import { icons } from '../../../images/index.js';

const stableArray = [];

const statusIconMap = {
  1: 'inbox',
  4: 'spam',
  3: 'archive',
};

const statusColorMap = {
  1: 'blue',
  4: 'orange',
  3: 'purple',
};

export const inboxMarkAsOptions = (statusId) => (state) => {
  const statuses = (state.app.event_statuses || stableArray).filter((n) => ['Spam', 'Inbox'].includes(n.status));
  return [...statuses, { id: '3', status: 'Other' }]
    .map((n) => ({
      id: n.id,
      label: n.status,
      icon: icons[`icon-${statusIconMap[n.id]}`],
      color: statusColorMap[n.id],
    }))
    .filter((n) => n.id !== statusId);
};
